import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import I18n from 'i18n-react'

// components
import TextInput from '../Components/_ui/TextInput.js'
import TilesList from '../Components/_ui/TilesList.js'

// redux
import DomexActions from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'
import { SCREENS } from '../Redux/NavigationRedux'
import { WEB_TYPES } from '../Redux/NavigationRedux'

class PropertyTypeContainer extends React.Component {
	static propTypes = {
		domexSetGiArea: PropTypes.func.isRequired,
		domexSetGiSum: PropTypes.func.isRequired,
		domexSetOccupancy: PropTypes.func.isRequired,
		domexSetPropertyType: PropTypes.func.isRequired,
		domexValidationErrorPropertyTypeChange: PropTypes.func.isRequired,
		giBuiltUpArea: PropTypes.string.isRequired,
		giSumInsured: PropTypes.string.isRequired,
		groundingInsurance: PropTypes.object.isRequired,
		groundingOccupancyIndex: PropTypes.number.isRequired,
		groundingPropertyTypeIndex: PropTypes.number.isRequired,
		onSetScreenIsValid: PropTypes.func.isRequired,
		screenValidateSig: PropTypes.array.isRequired,
		validationErrorsPropertyType: PropTypes.object.isRequired,
		webType: PropTypes.number.isRequired,
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.screenValidateSig[SCREENS.PROPERTY_TYPE].validate === true) {
			const valid = this.handleValidate()
			nextProps.onSetScreenIsValid(SCREENS.PROPERTY_TYPE, valid)
		}
	}

	handleValidate = () => this.giAreaInput.validate() && this.giSumInput.validate()

	handleSetPropertyType = (index) => {
		this.props.domexSetPropertyType(index)
	}

	handleSetOccupancy = (index) => {
		this.props.domexSetOccupancy(index)
	}

	handleSetGiArea = (value) => {
		this.props.domexSetGiArea(value)
	}

	handleSetGiSum = (value) => {
		this.props.domexSetGiSum(value)
	}

	handleOnErrorChange = (name, error) => {
		this.props.domexValidationErrorPropertyTypeChange(name, error, SCREENS.PROPERTY_TYPE)
	}

	render() {
		return (
			<div className='mb-4'>
				{this.props.webType !== WEB_TYPES.DEFAULT &&
				<h3>{I18n.translate('general.groundingDetailTitle')}</h3>
				}
				<h3>{I18n.translate('general.groundingType')}</h3>
				<TilesList
					activeIndex={this.props.groundingPropertyTypeIndex}
					name='propertyType'
					onChange={this.handleSetPropertyType}
					tiles={this.props.groundingInsurance.propertyType}
				/>
				<TextInput
					isNumber
					isRequired
					label={I18n.translate('general.giArea')}
					min={10}
					name='giBuiltUpArea'
					onChange={this.handleSetGiArea}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.giAreaInput = ref
					}}
					type='number'
					unit='m'
					unitExponent='2'
					validationErrors={this.props.validationErrorsPropertyType}
					value={this.props.giBuiltUpArea}
				/>
				<TextInput
					isNumber
					isRequired
					label={I18n.translate('general.giSum')}
					min={10000}
					name='giSumInsured'
					onChange={this.handleSetGiSum}
					onErrorChange={this.handleOnErrorChange}
					ref={ref => {
						this.giSumInput = ref
					}}
					type='number'
					unit='Kč'
					validationErrors={this.props.validationErrorsPropertyType}
					value={this.props.giSumInsured}
				/>
				{this.props.webType !== WEB_TYPES.HOUSEHOLD &&
				<div>
					<h3>{I18n.translate('general.groundingOccupancy')}</h3>
					<TilesList
						activeIndex={this.props.groundingOccupancyIndex}
						name='occupancy'
						onChange={this.handleSetOccupancy}
						tiles={this.props.groundingInsurance.occupancy}
					/>
				</div>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	giBuiltUpArea: state.domex.giBuiltUpArea,
	giSumInsured: state.domex.giSumInsured,
	groundingInsurance: state.domex.groundingInsurance,
	screenValidateSig: state.general.screenValidateSig,
	validationErrorsPropertyType: state.domex.validationErrorsPropertyType,
	groundingOccupancyIndex: state.domex.groundingOccupancyIndex,
	groundingPropertyTypeIndex: state.domex.groundingPropertyTypeIndex,
	webType: state.navigation.webType,
})

const mapDispatchToProps = {
	domexSetGiArea: DomexActions.domexSetGiArea,
	domexSetGiSum: DomexActions.domexSetGiSum,
	domexSetOccupancy: DomexActions.domexSetOccupancy,
	domexSetPropertyType: DomexActions.domexSetPropertyType,
	domexValidationErrorPropertyTypeChange: DomexActions.domexValidationErrorPropertyTypeChange,
	onSetScreenIsValid: GeneralActions.onSetScreenIsValid,
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyTypeContainer)
